var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 24C1.74 24 1.1752 23.7528 0.7056 23.2585C0.236 22.7642 0.0008 22.1693 0 21.4737V7.57895C0 6.88421 0.2352 6.28968 0.7056 5.79537C1.176 5.30105 1.7408 5.05347 2.4 5.05263H7.2V2.52632C7.2 1.83158 7.4352 1.23705 7.9056 0.742737C8.376 0.248421 8.9408 0.000842105 9.6 0H14.4C15.06 0 15.6252 0.247579 16.0956 0.742737C16.566 1.23789 16.8008 1.83242 16.8 2.52632V5.05263H21.6C22.26 5.05263 22.8252 5.30021 23.2956 5.79537C23.766 6.29053 24.0008 6.88505 24 7.57895V21.4737C24 22.1684 23.7652 22.7634 23.2956 23.2585C22.826 23.7537 22.2608 24.0008 21.6 24H2.4ZM9.6 5.05263H14.4V2.52632H9.6V5.05263Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitleIcon);
export default __webpack_public_path__ + "static/media/job-title-icon.5bf8214e7a1312891e3b4ae5eb471811.svg";
export { ForwardRef as ReactComponent };